const EventTypes = {
  REGISTERED_DEFAULT: 0,
  REGISTERED_SUBSCRIBER: 1,
  REGISTERED_TRIAL: 2,
  REGISTERED_DEPARTMENT_MAX: 3,
  REGISTRATION_ERROR_DEFAULT: 4,
  REGISTRATION_ERROR_FIELDS: 5,
  REGISTRATION_ERROR_NEEDS_ACTIVATION: 6,
  ACTIVATED_DEFAULT: 7,
  ACTIVATED_SUCCESS: 8,
  CLICKED_REGISTER: 9,
  SUBMITTED_REGISTRATION: 10,
  CLICKED_TAB_OFFICIAL_PLAN: 11,
  CLICKED_TAB_URBAN_STRUCTURE: 12,
  CLICKED_TAB_ZONING_BY_LAW: 13,
  CLICKED_TAB_DEV_APP: 14,
  CLICKED_TAB_WATER: 15,
  CLICKED_TAB_ENVIRONMENT: 16,
  CLICKED_TAB_PROVINCIAL_PLAN: 17,
  CLICKED_LINK_OFFICIAL_PLAN_MAP_PDF: 18,
  CLICKED_LINK_OFFICIAL_PLAN_REFERENCE: 19,
  CLICKED_LINK_ZONING_BY_LAW: 20,
  CLICKED_SHOW_TUTORIAL: 21,
  CLICKED_CLOSED_TUTORIAL: 22,
  CLICKED_NEXT_TUTORIAL1: 23,
  CLICKED_NEXT_TUTORIAL2: 24,
  CLICKED_FINISH_TUTORIAL: 25,
  CLICKED_FINISH_TUTORIAL1: 26,
  CLICKED_FINISH_TUTORIAL2: 27,
    
};

const EventsLoggingService = {
  EventTypes,

  _initialized: false,
  
  _logEvent: function (label, source, action, value) {
    ga('send', {
      hitType: 'event',
      eventCategory: source,
      eventAction: action,
      eventLabel: label,
      eventValue: value || 0
    });
  },
  initialize: function () {
    if (!this._initialized) {
      (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
          m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
      })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');

      ga('create', 'UA-53921428-1', 'auto');
      ga('send', 'pageview');
    }
    this._initialized = true;
  },

  registered: function (type) {
    if (type !== EventTypes.REGISTERED_DEFAULT &&
        type !== EventTypes.REGISTERED_SUBSCRIBER &&
        type !== EventTypes.REGISTERED_TRIAL &&
        type !== EventTypes.REGISTERED_DEPARTMENT_MAX) {
      
      throw new Error('Invalid event type');
    } else {
      this._logEvent('signup', 'form', 'registered', type);
    }    
  },
  
  activated: function (type) {
    if (type !== EventTypes.ACTIVATED_DEFAULT &&
        type !== EventTypes.ACTIVATED_SUCCESS) {

      throw new Error('Invalid event type');
    } else {
      this._logEvent('signup', 'dialog', 'activated', type);
    }
  },
  
  registrationError: function (type) {
    if (type !== EventTypes.REGISTRATION_ERROR_DEFAULT &&
        type !== EventTypes.REGISTRATION_ERROR_NEEDS_ACTIVATION && 
        type !== EventTypes.REGISTRATION_ERROR_FIELDS) {

      throw new Error('Invalid event type');
    } else {
      this._logEvent('signup', 'form', 'registration_error', type);
    }
  },
  
  clickedRegister: function () {
    this._logEvent('signup', 'button', 'clicked_register');
  },
  
  submittedRegistration: function () {
    this._logEvent('signup', 'button', 'submitted_registration');
  },
  
  clickedTab: function (tabId) {
    if (tabId !== EventTypes.CLICKED_TAB_OFFICIAL_PLAN &&
        tabId !== EventTypes.CLICKED_TAB_URBAN_STRUCTURE &&
        tabId !== EventTypes.CLICKED_TAB_ZONING_BY_LAW &&
        tabId !== EventTypes.CLICKED_TAB_DEV_APP &&
        tabId !== EventTypes.CLICKED_TAB_WATER &&
        tabId !== EventTypes.CLICKED_TAB_ENVIRONMENT &&
        tabId !== EventTypes.CLICKED_TAB_PROVINCIAL_PLAN) {
      throw new Error('Invalid tab event type');
    } else {
      this._logEvent('member', 'tab', 'clicked_tab', tabId);
    }
  },
  
  clickedMakeAReport: function () {
    this._logEvent('member', 'button', 'clicked_make_report');
  },
  
  clickedGenerateReport: function () {
    this._logEvent('member', 'button', 'clicked_generate_report');
  },

  clickedLink: function (type) {
    if (type !== EventTypes.CLICKED_LINK_OFFICIAL_PLAN_MAP_PDF && 
        type !== EventTypes.CLICKED_LINK_OFFICIAL_PLAN_REFERENCE &&
        type !== EventTypes.CLICKED_LINK_ZONING_BY_LAW) {
      throw new Error('Invalid link click type');
    } else {
      this._logEvent('member', 'link', 'clicked_link', type);
    }
  },
  
  clickedTutorial: function (type) {
    if (type !== EventTypes.CLICKED_SHOW_TUTORIAL && 
        type !== EventTypes.CLICKED_CLOSED_TUTORIAL && 
        type !== EventTypes.CLICKED_NEXT_TUTORIAL1 && 
        type !== EventTypes.CLICKED_NEXT_TUTORIAL2 && 
        type !== EventTypes.CLICKED_FINISH_TUTORIAL && 
        type !== EventTypes.CLICKED_FINISH_TUTORIAL1 && 
        type !== EventTypes.CLICKED_FINISH_TUTORIAL2) {
      throw new Error('Invalid tutorial click type');
    } else {
      this._logEvent('member', 'link', 'clicked_tutorial_link', type);
    }
  }
};

export default EventsLoggingService;



// WEBPACK FOOTER //
// ./public/js/EventsLoggingService.js